const keys = {
  LINK: {
    key: 'LINK',
    description: 'Nota fiscal',
  },
  MANUAL: {
    key: 'MANUAL',
    description: 'Manual',
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
